import React, { Component } from "react";
import { connect } from "react-redux";
import axios, { CancelToken } from "axios";
import { Translate, I18n } from "react-redux-i18n";
import QR from "qrcode.react";
import _ from "lodash";

import AddInfrastructure from "./modals/AddInfrastructure";
import EditInfrastructure from "./modals/EditInfrastructure";
import ActionCharger from "./modals/ActionCharger";
import AvailabilityAccess from "./modals/AvailabilityAccess";
import PlugInfo from "./modals/PlugInfo";
import ExportQR from "./modals/ExportQR";
import ChargeAs from "./modals/ChargeAs";
import ConfigurePlug from "./modals/ConfigurePlug";
import ControlRow from "../utils/components/ControlRow";
import ConfirmationModal from "../utils/components/ConfirmationModal";
import ChargeAnimation from "../utils/components/ChargeAnimation";
import ModularButtonPopup from "../utils/components/ModularButtonPopup";
import TooltipButton from "../utils/components/TooltipButton";

import { setAlert } from "../../actions/alertActions";
import {
  momentModule,
  searchModule,
  getPlug,
  getParkingType,
  getVehicleType,
  getFacilitiesType,
  getChargerStatus,
  getPlugStatus,
} from "../utils/Utils";
import Infrastructure from "../utils/classes/Infrastructure";

import "../../styles/utils/_loadingScreen.scss";
import "../../styles/components/chargers/MyChargers.scss";
import { ReactComponent as ThumbUpIcon } from "../../styles/images/thumb_up.svg";
import { ReactComponent as ThumbDownIcon } from "../../styles/images/thumb_down.svg";
import no_chargers from "../../styles/images/no_chargers.svg";
import plus from "../../styles/images/plus.svg";
import search from "../../styles/images/search.svg";
import cog from "../../styles/images/cog.svg";
import pencil from "../../styles/images/pencil.svg";
import trashcan from "../../styles/images/trashcan.svg";
import evio_busy from "../../styles/images/markers/marker_evio_busy.svg";
import marker_private_chargers from "../../styles/images/markers/marker_private_chargers.svg";
import marker_private_offline_chargers from "../../styles/images/markers/marker_private_offline_chargers.svg";

import { ReactComponent as LogsIcon } from "../../styles/images/logsIcon.svg";
import { ReactComponent as AvailabilityAccessIcon } from "../../styles/images/availability_access.svg";
import { ReactComponent as EnergyIcon } from "../../styles/images/energy_grey.svg";
import { ReactComponent as ConfigureKeysIcon } from "../../styles/images/configure_keys.svg";
import { ReactComponent as UnlockConnectorIcon } from "../../styles/images/unlock_connector.svg";
import { ReactComponent as ResetSoftIcon } from "../../styles/images/reset_soft.svg";
import { ReactComponent as ResetHardIcon } from "../../styles/images/reset_hard.svg";
import { ReactComponent as BatteryIcon } from "../../styles/images/battery_grey.svg";
import ThreeDotsIcon from "../utils/components/ThreeDotsIcon";
import ConfigurationKeys from "./modals/ConfigurationKeys";

import ViewLogsModal from "./modals/viewLogsModal";

const { moment } = momentModule;

class MyChargers extends Component {
  constructor(props) {
    super(props);
    this._mounted = false;
    this.cancel = null;
    this.componentRef = React.createRef();
    this.popupRef = React.createRef();

    this.state = {
      loading: true,
      search: "",
      places: [],
      selectedPlace: null,
      selectedCharger: null,
      selectedPlug: null,
      plugInfoTabIndex: 0,
      sessionId: -1,

      modals: {
        add: false,
        edit: false,
        delete: false,
        addCharger: false,
        editCharger: false,
        deleteCharger: false,
        availabilityAccess: false,
        plugInfo: false,
        chargeAnim: false,
        configurePlugs: false,
        configureKeys: false,
        exportQR: false,
        chargeAs: false,
      },
    };

    this.fetchPlaces = this.fetchPlaces.bind(this);
    this.handleAddInfrastructure = this.handleAddInfrastructure.bind(this);
    this.handleEditInfrastructure = this.handleEditInfrastructure.bind(this);
    this.handleDeleteInfrastructure =
      this.handleDeleteInfrastructure.bind(this);
    this.handleDeleteCharger = this.handleDeleteCharger.bind(this);
    this.handleAddCharger = this.handleAddCharger.bind(this);
    this.handleEditCharger = this.handleEditCharger.bind(this);
    this.handleOnClickQRCode = this.handleOnClickQRCode.bind(this);
    this.handleAvailabilityChange = this.handleAvailabilityChange.bind(this);
    this.handleAccessChange = this.handleAccessChange.bind(this);
    this.handleOnCharge = this.handleOnCharge.bind(this);
    this.handleOnUnlockConnector = this.handleOnUnlockConnector.bind(this);
    this.handleOnReset = this.handleOnReset.bind(this);
    this.handleOnSelect = this.handleOnSelect.bind(this);
    this.getPopupRef = this.getPopupRef.bind(this);
    this.handleEvsChargeAsChange = this.handleEvsChargeAsChange.bind(this);
    this.handleCardsChargeAsChange = this.handleCardsChargeAsChange.bind(this);

    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  componentDidMount() {
    this._mounted = true;
    this.fetchPlaces();
  }

  componentWillUnmount() {
    this._mounted = false;
    if (this.cancel) this.cancel("Component is unmounting");
  }

  openModal() {
    this.setState({ modalOpen: true });
  }

  closeModal() {
    this.setState({ modalOpen: false });
  }

  fetchPlaces() {
    axios
      .get("/api/private/infrastructure/myInfrastructure", {
        cancelToken: new CancelToken((c) => (this.cancel = c)),
      })
      .then((res) => {
        this.safeSetState(
          {
            loading: false,
            places: res.data.map((p) => new Infrastructure(p)),
          },
          () => {
            if (this.state.places.length > 0) {
              let idx = -1;
              if (this.state.selectedPlace)
                idx = this.state.places.findIndex(
                  (p) => p._id === this.state.selectedPlace._id
                );
              this.safeSetState({
                selectedPlace:
                  idx !== -1 ? this.state.places[idx] : this.state.places[0],
              });
            }
          }
        );
      })
      .catch((err) =>
        this.props.setAlert(I18n.t(err.response.data.message), "danger")
      );
  }

  parseStatus(chargerStatus, plugStatus, operationalStatus) {
    if (getChargerStatus(chargerStatus) === "online") {
      switch (getPlugStatus(plugStatus)) {
        case "available": {
          return operationalStatus === "WAITINGAPROVAL" ? (
            <>
              <img
                src={
                  this.props.brand?.icons?.mapIcons?.[
                    `marker_${_.camelCase(
                      this.props.brand?.brandName
                    )}_available`
                  ] || marker_private_chargers
                }
                alt=""
              />
              <div>
                <Translate value="myChargers_available" />
                <p>
                  <Translate value="myChargers_waiting_approval" />
                </p>
              </div>
            </>
          ) : (
            <>
              <img
                src={
                  this.props.brand?.icons?.mapIcons?.[
                    `marker_${_.camelCase(
                      this.props.brand?.brandName
                    )}_available`
                  ] || marker_private_chargers
                }
                alt=""
              />
              <Translate value="myChargers_available" />
            </>
          );
        }
        case "in-use": {
          return operationalStatus === "WAITINGAPROVAL" ? (
            <>
              <img
                src={
                  this.props.brand?.icons?.mapIcons?.[
                    `marker_${_.camelCase(this.props.brand?.brandName)}_busy`
                  ] || evio_busy
                }
                alt=""
              />
              <div>
                <Translate value="myChargers_inUse" />
                <p>
                  <Translate value="myChargers_waiting_approval" />
                </p>
              </div>
            </>
          ) : (
            <>
              <img
                src={
                  this.props.brand?.icons?.mapIcons?.[
                    `marker_${_.camelCase(this.props.brand?.brandName)}_busy`
                  ] || evio_busy
                }
                alt=""
              />
              <Translate value="myChargers_inUse" />
            </>
          );
        }
        case "unavailable": {
          return operationalStatus === "WAITINGAPROVAL" ? (
            <>
              <img
                src={
                  this.props.brand?.icons?.mapIcons?.[
                    `marker_${_.camelCase(this.props.brand?.brandName)}_offline`
                  ] || marker_private_offline_chargers
                }
                alt=""
              />
              <div>
                <Translate value="myChargers_offline" />
                <p>
                  <Translate value="myChargers_waiting_approval" />
                </p>
              </div>
            </>
          ) : (
            <>
              <img
                src={
                  this.props.brand?.icons?.mapIcons?.[
                    `marker_${_.camelCase(this.props.brand?.brandName)}_offline`
                  ] || marker_private_offline_chargers
                }
                alt=""
              />
              <Translate value="myChargers_offline" />
            </>
          );
        }
        default:
          return operationalStatus === "WAITINGAPROVAL" ? (
            <>
              <img
                src={
                  this.props.brand?.icons?.mapIcons?.[
                    `marker_${_.camelCase(this.props.brand?.brandName)}_offline`
                  ] || marker_private_offline_chargers
                }
                alt=""
              />
              <div>
                <Translate value="myChargers_unknown" />
                <p>
                  <Translate value="myChargers_waiting_approval" />
                </p>
              </div>
            </>
          ) : (
            <>
              <img
                src={
                  this.props.brand?.icons?.mapIcons?.[
                    `marker_${_.camelCase(this.props.brand?.brandName)}_offline`
                  ] || marker_private_offline_chargers
                }
                alt=""
              />
              <Translate value="myChargers_unknown" />
            </>
          );
      }
    } else {
      return operationalStatus === "WAITINGAPROVAL" ? (
        <>
          <img
            src={
              this.props.brand?.icons?.mapIcons?.[
                `marker_${_.camelCase(this.props.brand?.brandName)}_offline`
              ] || marker_private_offline_chargers
            }
            alt=""
          />
          <div>
            <Translate value="myChargers_offline" />
            <p>
              <Translate value="myChargers_waiting_approval" />
            </p>
          </div>
        </>
      ) : (
        <>
          <img
            src={
              this.props.brand?.icons?.mapIcons?.[
                `marker_${_.camelCase(this.props.brand?.brandName)}_offline`
              ] || marker_private_offline_chargers
            }
            alt=""
          />
          <Translate value="myChargers_offline" />
        </>
      );
    }
  }

  handleAddInfrastructure(elements, imageContent) {
    const name = elements.name.value;
    const CPE = elements.cpe.value;

    if (imageContent === null) {
      this.props.setAlert(I18n.t("myChargersAddInfr_empty_image"), "danger");
      return;
    }

    const post = {
      name,
      CPE,
      imageContent,
    };

    axios
      .post("/api/private/infrastructure", post, {
        cancelToken: new CancelToken((c) => (this.cancel = c)),
      })
      .then((res) => {
        const place = new Infrastructure(res.data);

        this.safeSetState(
          (prevState) => ({
            places: [...prevState.places, place],
            selectedPlace: place,
          }),
          () => {
            this.setModal("add", false);
            this.fetchPlaces();
          }
        );
      })
      .catch((err) =>
        this.props.setAlert(I18n.t(err.response.data.message), "danger")
      );
  }

  handleEditInfrastructure(elements, imageContent) {
    const name = elements.name.value;
    const CPE = elements.cpe.value;

    const patch = {
      _id: this.state.selectedPlace._id,
      name,
      CPE,
      imageContent,
    };
    axios
      .patch("/api/private/infrastructure", patch, {
        cancelToken: new CancelToken((c) => (this.cancel = c)),
      })
      .then((res) => {
        if (res.status === 200) {
          this.props.setAlert(
            I18n.t("myChargers_editChargerPlaceSuccess"),
            "primary"
          );
          this.fetchPlaces();
          this.setModal("edit", false);
        }
      })
      .catch((err) =>
        this.props.setAlert(I18n.t(err.response.data.message), "danger")
      );
  }

  handleDeleteInfrastructure() {
    if (this.state.selectedPlace) {
      axios
        .delete("/api/private/infrastructure", {
          data: { _id: this.state.selectedPlace._id },
          cancelToken: new CancelToken((c) => (this.cancel = c)),
        })
        .then((res) => {
          if (res.status === 200) {
            this.props.setAlert(
              I18n.t("myChargers_deleteChargerPlaceSuccess"),
              "primary"
            );
            this.fetchPlaces();
            this.setModal("delete", false);
          }
        })
        .catch((err) =>
          this.props.setAlert(I18n.t(err.response.data.message), "danger")
        );
    }
  }

  handleAddCharger(
    form,
    location,
    parkingType,
    vehicleType,
    facilitiesTypes,
    picture
  ) {
    const elements = form.elements;
    const name = elements.chargerName.value;
    const serial = elements.chargerSerial.value;
    const serialNumber = elements.chargerSerialNumber.value;
    const chargerInfrastructureCPE = elements.chargerInfrastructureCPE.checked;
    const CPE = chargerInfrastructureCPE
      ? this.state.selectedPlace.CPE ?? ""
      : elements.chargerCPE.value;
    const booking = elements.chargerBooking.checked;
    const rfid = elements.chargerRFID.checked;
    const confirmation = elements.chargerConfirmation.checked;
    const info = elements.chargerInfo.value;
    const internalInfo = elements.chargerInternalInfo?.value;
    const parking = getParkingType(
      parkingType.findIndex((p) => p)
    ).camelcaseName;
    const vehicles = vehicleType
      .map((v, i) => {
        if (v) return { vehicle: getVehicleType(i).camelcaseName };
        return false;
      })
      .filter((i) => i);
    const facilities = facilitiesTypes
      .map((v, i) => {
        if (v) return { facility: getFacilitiesType(i).camelcaseName };
        return false;
      })
      .filter((i) => i);
    const imageContent = picture.length !== 0 ? [...picture] : [];
    const allowOfflineNotification = elements.allowOfflineNotification.checked;
    const allowOfflineNotificationEmail = allowOfflineNotification
      ? elements.allowOfflineNotificationEmail.value
      : "";
    const chargingDistance = elements.chargingDistance.value;

    const post = {
      hasInfrastructure: true,
      infrastructure: this.state.selectedPlace._id,
      hwId: serial,
      serialNumber,
      name,
      address: location.address,
      geometry: {
        coordinates: location.coords,
      },
      CPE,
      instantBooking: booking,
      allowRFID: rfid,
      requireConfirmation: confirmation,
      parkingType: parking,
      vehiclesType: vehicles,
      facilitiesTypes: facilities,
      defaultImage: "0",
      imageContent,
      infoPoints: info,
      internalInfo,
      offlineNotification: allowOfflineNotification,
      offlineEmailNotification: allowOfflineNotificationEmail,
      chargingDistance,
    };

    axios
      .post("/api/private/chargers", post, {
        cancelToken: new CancelToken((c) => (this.cancel = c)),
      })
      .then((res) => {
        if (res.status === 200) {
          this.props.setAlert(
            I18n.t("myChargersAddCharger_success"),
            "primary"
          );
          this.fetchPlaces();
          this.setModal("addCharger", false);
        }
      })
      .catch((err) =>
        this.props.setAlert(I18n.t(err.response.data.message), "danger")
      );
  }

  handleEditCharger(
    _id,
    form,
    location,
    parkingType,
    vehicleType,
    facilitiesTypes,
    imageContent
  ) {
    const elements = form.elements;
    const name = elements.chargerName.value;
    const serial = elements.chargerSerial.value;
    const serialNumber = elements.chargerSerialNumber.value;
    const chargerInfrastructureCPE = elements.chargerInfrastructureCPE.checked;
    const CPE = chargerInfrastructureCPE
      ? this.state.selectedPlace.CPE ?? ""
      : elements.chargerCPE.value;
    const booking = elements.chargerBooking.checked;
    const rfid = elements.chargerRFID.checked;
    const confirmation = elements.chargerConfirmation.checked;
    const info = elements.chargerInfo.value;
    const internalInfo = elements.chargerInternalInfo?.value;
    const parking = getParkingType(
      parkingType.findIndex((p) => p)
    ).camelcaseName;
    const vehicles = vehicleType
      .map((v, i) => {
        if (v) return { vehicle: getVehicleType(i).camelcaseName };
        return false;
      })
      .filter((i) => i);
    const facilities = facilitiesTypes
      .map((v, i) => {
        if (v) return { facility: getFacilitiesType(i).camelcaseName };
        return false;
      })
      .filter((i) => i);
    const allowOfflineNotification = elements.allowOfflineNotification.checked;
    const allowOfflineNotificationEmail = allowOfflineNotification
      ? elements.allowOfflineNotificationEmail.value
      : "";
    const chargingDistance = elements.chargingDistance.value;

    const patch = {
      _id,
      hasInfrastructure: true,
      infrastructure: this.state.selectedPlace._id,
      hwId: serial,
      serialNumber,
      name,
      address: location.address,
      geometry: {
        coordinates: location.coords,
      },
      CPE,
      instantBooking: booking,
      allowRFID: rfid,
      requireConfirmation: confirmation,
      parkingType: parking,
      vehiclesType: vehicles,
      facilitiesTypes: facilities,
      defaultImage: "0",
      imageContent,
      infoPoints: info,
      internalInfo,
      offlineNotification: allowOfflineNotification,
      offlineEmailNotification: allowOfflineNotificationEmail,
      chargingDistance,
    };

    axios
      .patch("/api/private/chargers", patch, {
        cancelToken: new CancelToken((c) => (this.cancel = c)),
      })
      .then((res) => {
        if (res.status === 200) {
          this.props.setAlert(
            I18n.t("myChargersEditCharger_success"),
            "primary"
          );
          this.fetchPlaces();
          this.setModal("editCharger", false);
        }
      })
      .catch((err) =>
        this.props.setAlert(I18n.t(err.response.data.message), "danger")
      );
  }

  handleDeleteCharger() {
    if (!this.props.isAdmin) window.location.assign("../support");
    else
      axios
        .delete("/api/private/chargers", {
          data: {
            _id: this.state.selectedCharger.chargerId,
          },
          cancelToken: new CancelToken((c) => (this.cancel = c)),
        })
        .then((res) => {
          if (res.status === 200) {
            this.props.setAlert(
              I18n.t("myChargersDeleteCharger_success"),
              "primary"
            );
            this.fetchPlaces();
            this.setModal("deleteCharger", false);
          }
        })
        .catch((err) =>
          this.props.setAlert(I18n.t(err.response.data.message), "danger")
        );
  }

  handleOnClickQRCode(e, selectedCharger, selectedPlug) {
    e.stopPropagation();
    this.safeSetState({ selectedCharger, selectedPlug }, () =>
      this.setModal("exportQR", true)
    );
  }

  handleAvailabilityChange(availabilityType, availabilityDays) {
    const availability = { availabilityType, ...availabilityDays };
    axios
      .patch(
        "/api/private/chargers/updateAvailability",
        {
          _id: this.state.selectedCharger.chargerId,
          availability,
        },
        { cancelToken: new CancelToken((c) => (this.cancel = c)) }
      )
      .then((res) => {
        if (res.status === 200) {
          this.props.setAlert(
            I18n.t("myChargersAvailability_success"),
            "primary"
          );
          this.fetchPlaces();
          this.safeSetState({ selectedCharger: null }, () =>
            this.setModal("availabilityAccess", false)
          );
        }
      })
      .catch((err) =>
        this.props.setAlert(I18n.t(err.response.data.message), "danger")
      );
  }

  handleAccessChange(access) {
    const { accessType, mapVisibility, groups, fleets } = access;
    const listOfGroups = groups
      .filter((g) => g.checked)
      .map((g) => ({ groupName: g.name, groupId: g._id }));

    const listOfFleets = fleets
      .filter((g) => g.checked)
      .map((g) => ({ fleetName: g.name, fleetId: g._id }));

    let patch = {
      _id: this.state.selectedCharger.chargerId,
      accessType,
      listOfGroups,
      listOfFleets: listOfFleets,
    };

    // add mapVisibility flag if accessType is 'Public'
    if (accessType === "Public") Object.assign(patch, { mapVisibility });

    axios
      .patch("/api/private/chargers/updateAccessType", patch)
      .then((res) => {
        if (res.status === 200) {
          this.props.setAlert(I18n.t("myChargersAccess_success"), "primary");
          this.fetchPlaces();
          this.safeSetState({ selectedCharger: null }, () =>
            this.setModal("availabilityAccess", false)
          );
        }
      })
      .catch((err) =>
        this.props.setAlert(I18n.t(err.response.data.message), "danger")
      );
  }

  handleOnCharge(e) {
    axios
      .get("/api/private/contracts", {
        cancelToken: new CancelToken((c) => (this.cancel = c)),
      })
      .then((res) => {
        if (res.status === 200) {
          if (res.data.length > 0) {
            const userContracts = res.data.filter(
              (contract) => contract.contractType === "user"
            );
            if (userContracts.length > 0) {
              const post = {
                evId: "-1",
                chargerId: this.state.selectedCharger.hwId,
                hwId: this.state.selectedCharger.hwId,
                address: this.state.selectedCharger.address,
                fees: this.state.selectedCharger.fees,
                action: "start",
                plugId: this.state.selectedPlug.plugId,
                idTag: userContracts[0].networks[0].tokens[0].idTagDec,
                tariffId: "-1",
                chargerType: this.state.selectedCharger.chargerType,
              };

              axios
                .post("/api/private/connectionstation", post, {
                  cancelToken: new CancelToken((c) => (this.cancel = c)),
                })
                .then((res) => {
                  if (res.status === 200) {
                    const sessionId = res.data.sessionId;
                    this.safeSetState({ sessionId }, () =>
                      this.setModal("chargeAnim", true)
                    );
                  }
                })
                .catch((err) =>
                  this.props.setAlert(
                    I18n.t(err.response.data.message),
                    "danger"
                  )
                );
            }
          }
        }
      })
      .catch((err) =>
        this.props.setAlert(I18n.t(err.response.data.message), "danger")
      );
  }

  handleEvsChargeAsChange(selectedItemEv, cardId) {
    const { selectedCharger, selectedPlug } = this.state;

    const post = {
      evId: selectedItemEv._id,
      chargerId: selectedCharger.hwId,
      hwId: selectedCharger.hwId,
      address: selectedCharger.address,
      fees: selectedCharger.fees,
      action: "start",
      plugId: selectedPlug.plugId,
      idTag: cardId.networks[0].tokens[0].idTagDec,
      tariffId: "-1",
      chargerType: selectedCharger.chargerType,
    };

    axios
      .post("/api/private/connectionstation", post, {
        cancelToken: new CancelToken((c) => (this.cancel = c)),
      })
      .then((res) => {
        if (res.status === 200) {
          const sessionId = res.data.sessionId;
          this.safeSetState(
            {
              sessionId,
            },
            () => {
              this.setModal("chargeAs", false);
              this.setModal("chargeAnim", true);
            }
          );
        }
      })
      .catch((err) =>
        this.props.setAlert(I18n.t(err.response.data.message), "danger")
      );
  }

  handleCardsChargeAsChange(selectedItemCard) {
    const { selectedCharger, selectedPlug } = this.state;

    const post = {
      evId: selectedItemCard.evId,
      chargerId: selectedCharger.hwId,
      hwId: selectedCharger.hwId,
      address: selectedCharger.address,
      fees: selectedCharger.fees,
      action: "start",
      plugId: selectedPlug.plugId,
      idTag: selectedItemCard.networks[0].tokens[0].idTagDec,
      tariffId: "-1",
      chargerType: selectedCharger.chargerType,
    };

    axios
      .post("/api/private/connectionstation", post, {
        cancelToken: new CancelToken((c) => (this.cancel = c)),
      })
      .then((res) => {
        if (res.status === 200) {
          const sessionId = res.data.sessionId;
          this.safeSetState(
            {
              sessionId,
            },
            () => {
              this.setModal("chargeAs", false);
              this.setModal("chargeAnim", true);
            }
          );
        }
      })
      .catch((err) =>
        this.props.setAlert(I18n.t(err.response.data.message), "danger")
      );
  }

  handleOnUnlockConnector() {
    const post = {
      chargerId: this.state.selectedCharger.hwId,
      chargerType: this.state.selectedCharger.chargerType,
      action: "unlockConnector",
      hwId: this.state.selectedCharger.hwId,
      plugId: this.state.selectedPlug.plugId,
    };
    axios
      .post("/api/private/connectionstation", post, {
        cancelToken: new CancelToken((c) => (this.cancel = c)),
      })
      .then((res) => {
        if (res.status === 200) {
          this.props.setAlert(I18n.t("myChargers_unlockSuccessful"), "primary");
        }
      })
      .catch((err) =>
        this.props.setAlert(err.response?.data?.message || I18n.t("general_error"), "danger")
      );
  }

  handleOnReset(resetType) {
    const post = {
      chargerId: this.state.selectedCharger.hwId,
      chargerType: this.state.selectedCharger.chargerType,
      action: "reset",
      hwId: this.state.selectedCharger.hwId,
      resetType,
    };
    axios
      .post("/api/private/connectionstation", post, {
        cancelToken: new CancelToken((c) => (this.cancel = c)),
      })
      .then((res) => {
        if (res.status === 200) {
          this.props.setAlert(I18n.t("myChargers_resetSuccessful"), "primary");
          setTimeout(this.fetchPlaces, 5000); // wait 5 seconds, then update
        }
      })
      .catch((err) =>
        this.props.setAlert(err?.response?.data?.message, "danger")
      );
  }

  refreshContent() {
    this.fetchPlaces();
  }

  handleOnSelect(selectedPlace) {
    this.safeSetState({
      selectedPlace,
    });
  }

  getPopupRef() {
    return this.popupRef;
  }

  setModal(modal, bool, callback) {
    let newModals = Object.assign({}, this.state.modals);
    newModals[modal] = bool;
    this.safeSetState(
      {
        modals: newModals,
      },
      callback
    );
  }

  checkPlug(p) {
    return (
      p.connectorType &&
      p.amperage &&
      p.power &&
      p.voltage &&
      p.active &&
      p.connectorType !== "" &&
      p.amperage !== "" &&
      p.power !== "" &&
      p.voltage !== "" &&
      p.active !== "" &&
      p.connectorType !== "Unknown"
    );
  }

  checkTariff(plug, charger) {
    if (
      charger.accessType === "Private" ||
      charger.accessType === "FreeCharge"
    ) {
      return true;
    }

    if (!plug.tariff.length > 0) {
      return false;
    }

    let bool = true;

    plug.tariff.forEach((p) => {
      if (
        !(
          (p.tariffType &&
            p.groupName &&
            p.tariff &&
            p.name &&
            p.name !== "" &&
            p.tariffType !== "" &&
            p.groupName !== "" &&
            p.tariffType !== "Unknown") ||
          (p.tariffType &&
            p.fleetName &&
            p.tariff &&
            p.name &&
            p.name !== "" &&
            p.tariffType !== "" &&
            p.fleetName !== "" &&
            p.tariffType !== "Unknown")
        )
      ) {
        bool = false;
      }
    });
    return bool;
  }

  safeSetState(params, callback) {
    if (this._mounted) this.setState(params, callback);
  }

  manageChargerApproval(adminOrder) {
    const patch = {
      chargerId: this.state.selectedCharger.chargerId,
      operationalStatus: adminOrder,
    };

    axios
      .patch("/api/private/chargers/operationalStatus", patch, {
        cancelToken: new CancelToken((c) => (this.cancel = c)),
      })
      .then((res) => {
        if (res.status === 200) {
          this.refreshContent();
          this.props.setAlert(I18n.t("status_charger_saved"), "primary");
          this.safeSetState({ selectedCharger: null });
        }
      })
      .catch((err) =>
        this.props.setAlert(I18n.t(err.response.data.message), "danger")
      );
  }

  render() {
    return !this.state.loading ? (
      <>
        <div id="myChargers" className="main-container">
          <div className="control-bar">
            <ControlRow
              showSearch={this.state.selectedPlace !== null}
              search={this.state.search}
              onSearchChange={(e) =>
                searchModule.setSearch(this, e.target.value)
              }
              showCarousel={this.state.selectedPlace !== null}
              carousel={{
                items: this.state.places,
                selected: this.state.selectedPlace
                  ? this.state.places.findIndex(
                      (i) => i._id === this.state.selectedPlace._id
                    )
                  : 0,
                onSelect: this.handleOnSelect,
              }}
              buttons={[
                {
                  label: "myChargers_addChargerPlace",
                  text: plus,
                  onClick: () => this.setModal("add", true),
                  disabled:
                    this.state.loading ||
                    (this.props.isAdmin === false &&
                      this.state.places.length >=
                        this.props.userPackage?.chargingAreasLimit),
                },
                {
                  show: this.state.selectedPlace !== null,
                  text: (
                    <img
                      src={cog}
                      alt={I18n.t("myChargers_editChargerPlace")}
                    />
                  ),
                  className: "clear",
                  onClick: () => this.setModal("edit", true),
                },
                {
                  show: this.state.selectedPlace !== null,
                  text: (
                    <img
                      src={trashcan}
                      alt={I18n.t("myChargers_deleteChargerPlace")}
                    />
                  ),
                  className: "clear",
                  onClick: () => this.setModal("delete", true),
                },
              ]}
            />
          </div>
          {this.state.places.length === 0 && (
            <div className="no-places">
              <img src={no_chargers} alt="" className="back-car" />
              <p>
                <Translate value="chargers_noPlacesText" />
              </p>
            </div>
          )}
          {this.state.selectedPlace !== null && (
            <>
              <div className="component-container">
                <div className="table-container">
                  <div className="table-header">
                    <div className="row no-gutters">
                      <div className="col-10 row no-gutters titles">
                        <div className="col title">
                          <Translate value="sessions_charger" />
                        </div>
                        <div className="col title">
                          <Translate value="myChargers_plug" />
                        </div>
                        <div className="col title">
                          <Translate value="myChargers_qrCodeId" />
                        </div>
                        <div className="col title">
                          <Translate value="myChargers_status" />
                        </div>
                        <div className="col title">
                          <Translate value="myChargers_tariff" />
                        </div>
                        <div className="col-1 title">
                          {/* blank col for delete buttons */}
                        </div>
                      </div>
                      <div className="col-2 center">
                        {/* blank col for availabity and access buttons */}
                      </div>
                    </div>
                  </div>
                  <div className="table-values">
                    {this.state.selectedPlace?.listChargers
                      .filter((i) => searchModule.filter(this, i))
                      .map((c, k) => {
                        if (c.plugs?.length > 0) {
                          return c.plugs.map((p, idx) => {
                            return (
                              <div
                                key={`${c.chargerId}.${k}.${p.plugId}`}
                                className="row no-gutters"
                              >
                                <div
                                  className="col-10 row no-gutters values slim"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    if (
                                      this.checkPlug(p) &&
                                      this.checkTariff(p, c)
                                    )
                                      this.safeSetState(
                                        {
                                          selectedCharger: c,
                                          selectedPlug: p,
                                          plugInfoTabIndex: 0,
                                        },
                                        () => this.setModal("plugInfo", true)
                                      );
                                  }}
                                >
                                  <div className="row-overlay">
                                    <img
                                      src={search}
                                      alt={I18n.t("myChargers_chargerLabel")}
                                    />
                                  </div>

                                  <div className="col">
                                    <div className="charger-info-container">
                                      <p>{c.name}</p>
                                      <p>{c.hwId}</p>
                                    </div>
                                  </div>
                                  <div className="col">
                                    {this.checkPlug(p) ? (
                                      <>
                                        <img
                                          src={
                                            getPlug(p.connectorType).borderless
                                          }
                                          alt=""
                                        />
                                        <div className="plug-info-container">
                                          <p>{getPlug(p.connectorType).name}</p>
                                          <p>{p.plugId}</p>
                                        </div>
                                      </>
                                    ) : (
                                      <button
                                        type="button"
                                        className="link"
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          this.safeSetState(
                                            {
                                              selectedCharger: c,
                                              selectedPlug: p,
                                            },
                                            () =>
                                              this.setModal(
                                                "configurePlugs",
                                                true
                                              )
                                          );
                                        }}
                                      >
                                        <Translate
                                          className="no-plugs"
                                          value="myChargers_plugNotConfigurated"
                                        />
                                      </button>
                                    )}
                                  </div>
                                  <div className="col">
                                    <div className="qrcode-container">
                                      <div className="id-container">
                                        {p.qrCodeId || "-"}
                                      </div>
                                      {p.qrCodeId && (
                                        <div
                                          className="qr-container"
                                          onClick={(e) =>
                                            this.handleOnClickQRCode(e, c, p)
                                          }
                                        >
                                          <QR
                                            value={`https://link.go-evio.com/qrcode?id=${p.qrCodeId}`}
                                            size={30}
                                            level="H"
                                            bgColor="transparent"
                                            fgColor="#353841"
                                            renderAs="svg"
                                          />
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                  <div className="col">
                                    <div className="status">
                                      {this.parseStatus(
                                        c.status,
                                        p.status,
                                        c.operationalStatus
                                      )}
                                    </div>
                                  </div>
                                  <div className="col">
                                    <button
                                      type="button"
                                      className={
                                        "link " +
                                        (this.checkTariff(p, c)
                                          ? ""
                                          : "missing-tariff")
                                      }
                                      onClick={(e) => {
                                        e.stopPropagation();

                                        this.safeSetState(
                                          {
                                            selectedCharger: c,
                                            selectedPlug: p,
                                            plugInfoTabIndex: 1,
                                          },
                                          () => this.setModal("plugInfo", true)
                                        );
                                      }}
                                    >
                                      {this.checkTariff(p, c) ? (
                                        <Translate value="myChargers_consultTariff" />
                                      ) : (
                                        <Translate value="myChargers_missingTariff" />
                                      )}
                                    </button>
                                  </div>
                                  <div className="col-1 center">
                                    {this.props.isAdmin ? (
                                      c.operationalStatus === "APPROVED" ? (
                                        <TooltipButton
                                          tooltip={
                                            <Translate value="myChargers_unapproveCharger" />
                                          }
                                          type="button"
                                          className="clear admin-btn unapprove"
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            this.safeSetState(
                                              {
                                                selectedCharger: c,
                                                selectedPlug: p,
                                                plugInfoTabIndex: 0,
                                              },
                                              () => {
                                                this.manageChargerApproval(
                                                  "WAITINGAPROVAL"
                                                );
                                              }
                                            );
                                          }}
                                        >
                                          <ThumbDownIcon />
                                        </TooltipButton>
                                      ) : (
                                        <TooltipButton
                                          tooltip={
                                            <Translate value="myChargers_approveCharger" />
                                          }
                                          type="button"
                                          className="clear admin-btn approve"
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            this.safeSetState(
                                              {
                                                selectedCharger: c,
                                                selectedPlug: p,
                                                plugInfoTabIndex: 0,
                                              },
                                              () => {
                                                this.manageChargerApproval(
                                                  "APPROVED"
                                                );
                                              }
                                            );
                                          }}
                                        >
                                          <ThumbUpIcon />
                                        </TooltipButton>
                                      )
                                    ) : null}
                                    <button
                                      type="button"
                                      className="clear"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        this.safeSetState(
                                          { selectedCharger: c },
                                          () =>
                                            this.setModal("editCharger", true)
                                        );
                                      }}
                                    >
                                      <img src={pencil} alt="edit" />
                                    </button>
                                    <button
                                      type="button"
                                      className="clear"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        this.safeSetState(
                                          { selectedCharger: c },
                                          () =>
                                            this.setModal("deleteCharger", true)
                                        );
                                      }}
                                    >
                                      <img src={trashcan} alt="delete" />
                                    </button>
                                  </div>
                                </div>
                                {this.props.isAdmin ? (
                                  parseInt(p.status) === 40 ? (
                                    <div className="col-2 center blank">
                                      <div className="button-group">
                                        <TooltipButton
                                          tooltip={
                                            <Translate value="myChargers_availabilityAccess" />
                                          }
                                          type="button"
                                          className="availability-access-btn"
                                          onClick={() =>
                                            this.safeSetState(
                                              { selectedCharger: c },
                                              () =>
                                                this.setModal(
                                                  "availabilityAccess",
                                                  true
                                                )
                                            )
                                          }
                                        >
                                          <AvailabilityAccessIcon />
                                        </TooltipButton>
                                        <ModularButtonPopup
                                          label={<ThreeDotsIcon />}
                                          className="clear more-options-btn"
                                          popupClassName="modular-popup"
                                        >
                                          {this.props.isAdmin && (
                                            <TooltipButton
                                              tooltip={
                                                <Translate value="myChargers_configureKeys" />
                                              }
                                              tooltipOffset={this.getPopupRef}
                                              type="button"
                                              className="configure-keys-btn"
                                              onClick={() =>
                                                this.safeSetState(
                                                  { selectedCharger: c },
                                                  () =>
                                                    this.setModal(
                                                      "configureKeys",
                                                      true
                                                    )
                                                )
                                              }
                                            >
                                              <ConfigureKeysIcon />
                                            </TooltipButton>
                                          )}

                                          <TooltipButton
                                            tooltip={
                                              <Translate value="myChargers_logsDescription" />
                                            }
                                            tooltipOffset={this.getPopupRef}
                                            type="button"
                                            className="unlock-connector-btn"
                                            onClick={() =>
                                              this.safeSetState(
                                                { selectedCharger: c },
                                                () =>
                                                  this.setState({
                                                    modalOpen: true,
                                                  })
                                              )
                                            }
                                          >
                                            <LogsIcon />
                                          </TooltipButton>

                                          <TooltipButton
                                            tooltip={
                                              <Translate value="myChargers_unlockConnector" />
                                            }
                                            tooltipOffset={this.getPopupRef}
                                            type="button"
                                            className="unlock-connector-btn"
                                            onClick={() =>
                                              this.safeSetState(
                                                {
                                                  selectedCharger: c,
                                                  selectedPlug: p,
                                                },
                                                this.handleOnUnlockConnector
                                              )
                                            }
                                          >
                                            <UnlockConnectorIcon />
                                          </TooltipButton>
                                          <TooltipButton
                                            tooltip={
                                              <Translate value="myChargers_softReset" />
                                            }
                                            tooltipOffset={this.getPopupRef}
                                            type="button"
                                            className="reset-soft-btn"
                                            onClick={() =>
                                              this.safeSetState(
                                                {
                                                  selectedCharger: c,
                                                  selectedPlug: p,
                                                },
                                                () => this.handleOnReset("Soft")
                                              )
                                            }
                                          >
                                            <ResetSoftIcon />
                                          </TooltipButton>
                                          <TooltipButton
                                            tooltip={
                                              <Translate value="myChargers_hardReset" />
                                            }
                                            tooltipOffset={this.getPopupRef}
                                            type="button"
                                            className="reset-hard-btn"
                                            onClick={() =>
                                              this.safeSetState(
                                                {
                                                  selectedCharger: c,
                                                  selectedPlug: p,
                                                },
                                                () => this.handleOnReset("Hard")
                                              )
                                            }
                                          >
                                            <ResetHardIcon />
                                          </TooltipButton>
                                        </ModularButtonPopup>
                                      </div>
                                    </div>
                                  ) : parseInt(p.status) === 20 ? (
                                    <div className="col-2 center blank">
                                      <div className="button-group">
                                        <TooltipButton
                                          tooltip={
                                            <Translate value="myChargers_availabilityAccess" />
                                          }
                                          type="button"
                                          className="availability-access-btn"
                                          onClick={() =>
                                            this.safeSetState(
                                              { selectedCharger: c },
                                              () =>
                                                this.setModal(
                                                  "availabilityAccess",
                                                  true
                                                )
                                            )
                                          }
                                        >
                                          <AvailabilityAccessIcon />
                                        </TooltipButton>
                                        <TooltipButton
                                          tooltip={
                                            <Translate value="chargerDetails_charging" />
                                          }
                                          type="button"
                                          className="charging charge-btn"
                                          onClick={() =>
                                            window.location.assign(
                                              "../sessions"
                                            )
                                          }
                                        >
                                          <BatteryIcon />
                                        </TooltipButton>
                                        <ModularButtonPopup
                                          label={<ThreeDotsIcon />}
                                          className="clear more-options-btn"
                                          popupClassName="modular-popup"
                                        >
                                          {this.props.isAdmin && (
                                            <TooltipButton
                                              tooltip={
                                                <Translate value="myChargers_configureKeys" />
                                              }
                                              tooltipOffset={this.getPopupRef}
                                              type="button"
                                              className="configure-keys-btn"
                                              onClick={() =>
                                                this.safeSetState(
                                                  { selectedCharger: c },
                                                  () =>
                                                    this.setModal(
                                                      "configureKeys",
                                                      true
                                                    )
                                                )
                                              }
                                            >
                                              <ConfigureKeysIcon />
                                            </TooltipButton>
                                          )}
                                          <TooltipButton
                                            tooltip={
                                              <Translate value="myChargers_logsDescription" />
                                            }
                                            tooltipOffset={this.getPopupRef}
                                            type="button"
                                            className="unlock-connector-btn"
                                            onClick={() =>
                                              this.safeSetState(
                                                { selectedCharger: c },
                                                () =>
                                                  this.setState({
                                                    modalOpen: true,
                                                  })
                                              )
                                            }
                                          >
                                            <LogsIcon />
                                          </TooltipButton>
                                          <TooltipButton
                                            tooltip={
                                              <Translate value="myChargers_unlockConnector" />
                                            }
                                            tooltipOffset={this.getPopupRef}
                                            type="button"
                                            className="unlock-connector-btn"
                                            onClick={() =>
                                              this.safeSetState(
                                                {
                                                  selectedCharger: c,
                                                  selectedPlug: p,
                                                },
                                                this.handleOnUnlockConnector
                                              )
                                            }
                                          >
                                            <UnlockConnectorIcon />
                                          </TooltipButton>
                                          <TooltipButton
                                            tooltip={
                                              <Translate value="myChargers_softReset" />
                                            }
                                            tooltipOffset={this.getPopupRef}
                                            type="button"
                                            className="reset-soft-btn"
                                            onClick={() =>
                                              this.safeSetState(
                                                {
                                                  selectedCharger: c,
                                                  selectedPlug: p,
                                                },
                                                () => this.handleOnReset("Soft")
                                              )
                                            }
                                          >
                                            <ResetSoftIcon />
                                          </TooltipButton>
                                          <TooltipButton
                                            tooltip={
                                              <Translate value="myChargers_hardReset" />
                                            }
                                            tooltipOffset={this.getPopupRef}
                                            type="button"
                                            className="reset-hard-btn"
                                            onClick={() =>
                                              this.safeSetState(
                                                {
                                                  selectedCharger: c,
                                                  selectedPlug: p,
                                                },
                                                () => this.handleOnReset("Hard")
                                              )
                                            }
                                          >
                                            <ResetHardIcon />
                                          </TooltipButton>
                                        </ModularButtonPopup>
                                      </div>
                                    </div>
                                  ) : (
                                    <div className="col-2 center blank">
                                      <div className="button-group">
                                        <TooltipButton
                                          tooltip={
                                            <Translate value="myChargers_availabilityAccess" />
                                          }
                                          type="button"
                                          className="availability-access-btn"
                                          onClick={() =>
                                            this.safeSetState(
                                              { selectedCharger: c },
                                              () =>
                                                this.setModal(
                                                  "availabilityAccess",
                                                  true
                                                )
                                            )
                                          }
                                        >
                                          <AvailabilityAccessIcon />
                                        </TooltipButton>
                                        <div className="charge-btn-section">
                                          <TooltipButton
                                            tooltip={
                                              <Translate value="chargerDetails_charge" />
                                            }
                                            type="button"
                                            className="charge-btn"
                                            onClick={() =>
                                              this.safeSetState(
                                                {
                                                  selectedCharger: c,
                                                  selectedPlug: p,
                                                },
                                                this.handleOnCharge
                                              )
                                            }
                                          >
                                            <EnergyIcon />
                                          </TooltipButton>
                                          <TooltipButton
                                            tooltip={
                                              <Translate value="chargerAsDetails_charge" />
                                            }
                                            type="button"
                                            className="charge-as-btn"
                                            onClick={() =>
                                              this.safeSetState(
                                                {
                                                  selectedCharger: c,
                                                  selectedPlug: p,
                                                },
                                                () =>
                                                  this.setModal(
                                                    "chargeAs",
                                                    true
                                                  )
                                              )
                                            }
                                          >
                                            <EnergyIcon />
                                          </TooltipButton>
                                        </div>
                                        <ModularButtonPopup
                                          label={<ThreeDotsIcon />}
                                          className="clear more-options-btn"
                                          popupClassName="modular-popup"
                                        >
                                          {this.props.isAdmin && (
                                            <TooltipButton
                                              tooltip={
                                                <Translate value="myChargers_configureKeys" />
                                              }
                                              tooltipOffset={this.getPopupRef}
                                              type="button"
                                              className="configure-keys-btn"
                                              onClick={() =>
                                                this.safeSetState(
                                                  { selectedCharger: c },
                                                  () =>
                                                    this.setModal(
                                                      "configureKeys",
                                                      true
                                                    )
                                                )
                                              }
                                            >
                                              <ConfigureKeysIcon />
                                            </TooltipButton>
                                          )}
                                          <TooltipButton
                                            tooltip={
                                              <Translate value="myChargers_logsDescription" />
                                            }
                                            tooltipOffset={this.getPopupRef}
                                            type="button"
                                            className="unlock-connector-btn"
                                            onClick={() =>
                                              this.safeSetState(
                                                { selectedCharger: c },
                                                () =>
                                                  this.setState({
                                                    modalOpen: true,
                                                  })
                                              )
                                            }
                                          >
                                            <LogsIcon />
                                          </TooltipButton>
                                          <TooltipButton
                                            tooltip={
                                              <Translate value="myChargers_unlockConnector" />
                                            }
                                            tooltipOffset={this.getPopupRef}
                                            type="button"
                                            className="unlock-connector-btn"
                                            onClick={() =>
                                              this.safeSetState(
                                                {
                                                  selectedCharger: c,
                                                  selectedPlug: p,
                                                },
                                                this.handleOnUnlockConnector
                                              )
                                            }
                                          >
                                            <UnlockConnectorIcon />
                                          </TooltipButton>
                                          <TooltipButton
                                            tooltip={
                                              <Translate value="myChargers_softReset" />
                                            }
                                            tooltipOffset={this.getPopupRef}
                                            type="button"
                                            className="reset-soft-btn"
                                            onClick={() =>
                                              this.safeSetState(
                                                {
                                                  selectedCharger: c,
                                                  selectedPlug: p,
                                                },
                                                () => this.handleOnReset("Soft")
                                              )
                                            }
                                          >
                                            <ResetSoftIcon />
                                          </TooltipButton>
                                          <TooltipButton
                                            tooltip={
                                              <Translate value="myChargers_hardReset" />
                                            }
                                            tooltipOffset={this.getPopupRef}
                                            type="button"
                                            className="reset-hard-btn"
                                            onClick={() =>
                                              this.safeSetState(
                                                {
                                                  selectedCharger: c,
                                                  selectedPlug: p,
                                                },
                                                () => this.handleOnReset("Hard")
                                              )
                                            }
                                          >
                                            <ResetHardIcon />
                                          </TooltipButton>
                                        </ModularButtonPopup>
                                      </div>
                                    </div>
                                  )
                                ) : c.operationalStatus !== "APPROVED" ? (
                                  <div className="col-2 center blank">
                                    <div className="button-group">
                                      <TooltipButton
                                        tooltip={
                                          <Translate value="myChargers_availabilityAccess" />
                                        }
                                        type="button"
                                        className="availability-access-btn"
                                        onClick={() =>
                                          this.safeSetState(
                                            { selectedCharger: c },
                                            () =>
                                              this.setModal(
                                                "availabilityAccess",
                                                true
                                              )
                                          )
                                        }
                                        extended
                                      >
                                        <AvailabilityAccessIcon />
                                      </TooltipButton>
                                    </div>
                                  </div>
                                ) : parseInt(p.status) === 40 ? (
                                  <div className="col-2 center blank">
                                    <div className="button-group">
                                      <TooltipButton
                                        tooltip={
                                          <Translate value="myChargers_availabilityAccess" />
                                        }
                                        type="button"
                                        className="availability-access-btn"
                                        onClick={() =>
                                          this.safeSetState(
                                            { selectedCharger: c },
                                            () =>
                                              this.setModal(
                                                "availabilityAccess",
                                                true
                                              )
                                          )
                                        }
                                      >
                                        <AvailabilityAccessIcon />
                                      </TooltipButton>
                                      <ModularButtonPopup
                                        label={<ThreeDotsIcon />}
                                        className="clear more-options-btn"
                                        popupClassName="modular-popup"
                                      >
                                        {this.props.isAdmin && (
                                          <TooltipButton
                                            tooltip={
                                              <Translate value="myChargers_configureKeys" />
                                            }
                                            tooltipOffset={this.getPopupRef}
                                            type="button"
                                            className="configure-keys-btn"
                                            onClick={() =>
                                              this.safeSetState(
                                                { selectedCharger: c },
                                                () =>
                                                  this.setModal(
                                                    "configureKeys",
                                                    true
                                                  )
                                              )
                                            }
                                          >
                                            <ConfigureKeysIcon />
                                          </TooltipButton>
                                        )}

                                        <TooltipButton
                                          tooltip={
                                            <Translate value="myChargers_logsDescription" />
                                          }
                                          tooltipOffset={this.getPopupRef}
                                          type="button"
                                          className="unlock-connector-btn"
                                          onClick={() =>
                                            this.safeSetState(
                                              { selectedCharger: c },
                                              () =>
                                                this.setState({
                                                  modalOpen: true,
                                                })
                                            )
                                          }
                                        >
                                          <LogsIcon />
                                        </TooltipButton>
                                        <TooltipButton
                                          tooltip={
                                            <Translate value="myChargers_unlockConnector" />
                                          }
                                          tooltipOffset={this.getPopupRef}
                                          type="button"
                                          className="unlock-connector-btn"
                                          onClick={() =>
                                            this.safeSetState(
                                              {
                                                selectedCharger: c,
                                                selectedPlug: p,
                                              },
                                              this.handleOnUnlockConnector
                                            )
                                          }
                                        >
                                          <UnlockConnectorIcon />
                                        </TooltipButton>
                                        <TooltipButton
                                          tooltip={
                                            <Translate value="myChargers_softReset" />
                                          }
                                          tooltipOffset={this.getPopupRef}
                                          type="button"
                                          className="reset-soft-btn"
                                          onClick={() =>
                                            this.safeSetState(
                                              {
                                                selectedCharger: c,
                                                selectedPlug: p,
                                              },
                                              () => this.handleOnReset("Soft")
                                            )
                                          }
                                        >
                                          <ResetSoftIcon />
                                        </TooltipButton>
                                        <TooltipButton
                                          tooltip={
                                            <Translate value="myChargers_hardReset" />
                                          }
                                          tooltipOffset={this.getPopupRef}
                                          type="button"
                                          className="reset-hard-btn"
                                          onClick={() =>
                                            this.safeSetState(
                                              {
                                                selectedCharger: c,
                                                selectedPlug: p,
                                              },
                                              () => this.handleOnReset("Hard")
                                            )
                                          }
                                        >
                                          <ResetHardIcon />
                                        </TooltipButton>
                                      </ModularButtonPopup>
                                    </div>
                                  </div>
                                ) : parseInt(p.status) === 20 ? (
                                  <div className="col-2 center blank">
                                    <div className="button-group">
                                      <TooltipButton
                                        tooltip={
                                          <Translate value="myChargers_availabilityAccess" />
                                        }
                                        type="button"
                                        className="availability-access-btn"
                                        onClick={() =>
                                          this.safeSetState(
                                            { selectedCharger: c },
                                            () =>
                                              this.setModal(
                                                "availabilityAccess",
                                                true
                                              )
                                          )
                                        }
                                      >
                                        <AvailabilityAccessIcon />
                                      </TooltipButton>
                                      <TooltipButton
                                        tooltip={
                                          <Translate value="chargerDetails_charging" />
                                        }
                                        type="button"
                                        className="charging charge-btn"
                                        onClick={() =>
                                          window.location.assign("../sessions")
                                        }
                                      >
                                        <BatteryIcon />
                                      </TooltipButton>
                                      <ModularButtonPopup
                                        label={<ThreeDotsIcon />}
                                        className="clear more-options-btn"
                                        popupClassName="modular-popup"
                                      >
                                        {this.props.isAdmin && (
                                          <TooltipButton
                                            tooltip={
                                              <Translate value="myChargers_configureKeys" />
                                            }
                                            tooltipOffset={this.getPopupRef}
                                            type="button"
                                            className="configure-keys-btn"
                                            onClick={() =>
                                              this.safeSetState(
                                                { selectedCharger: c },
                                                () =>
                                                  this.setModal(
                                                    "configureKeys",
                                                    true
                                                  )
                                              )
                                            }
                                          >
                                            <ConfigureKeysIcon />
                                          </TooltipButton>
                                        )}

                                        <TooltipButton
                                          tooltip={
                                            <Translate value="myChargers_logsDescription" />
                                          }
                                          tooltipOffset={this.getPopupRef}
                                          type="button"
                                          className="unlock-connector-btn"
                                          onClick={() =>
                                            this.safeSetState(
                                              { selectedCharger: c },
                                              () =>
                                                this.setState({
                                                  modalOpen: true,
                                                })
                                            )
                                          }
                                        >
                                          <LogsIcon />
                                        </TooltipButton>
                                        <TooltipButton
                                          tooltip={
                                            <Translate value="myChargers_unlockConnector" />
                                          }
                                          tooltipOffset={this.getPopupRef}
                                          type="button"
                                          className="unlock-connector-btn"
                                          onClick={() =>
                                            this.safeSetState(
                                              {
                                                selectedCharger: c,
                                                selectedPlug: p,
                                              },
                                              this.handleOnUnlockConnector
                                            )
                                          }
                                        >
                                          <UnlockConnectorIcon />
                                        </TooltipButton>
                                        <TooltipButton
                                          tooltip={
                                            <Translate value="myChargers_softReset" />
                                          }
                                          tooltipOffset={this.getPopupRef}
                                          type="button"
                                          className="reset-soft-btn"
                                          onClick={() =>
                                            this.safeSetState(
                                              {
                                                selectedCharger: c,
                                                selectedPlug: p,
                                              },
                                              () => this.handleOnReset("Soft")
                                            )
                                          }
                                        >
                                          <ResetSoftIcon />
                                        </TooltipButton>
                                        <TooltipButton
                                          tooltip={
                                            <Translate value="myChargers_hardReset" />
                                          }
                                          tooltipOffset={this.getPopupRef}
                                          type="button"
                                          className="reset-hard-btn"
                                          onClick={() =>
                                            this.safeSetState(
                                              {
                                                selectedCharger: c,
                                                selectedPlug: p,
                                              },
                                              () => this.handleOnReset("Hard")
                                            )
                                          }
                                        >
                                          <ResetHardIcon />
                                        </TooltipButton>
                                      </ModularButtonPopup>
                                    </div>
                                  </div>
                                ) : (
                                  <div className="col-2 center blank">
                                    <div className="button-group">
                                      <TooltipButton
                                        tooltip={
                                          <Translate value="myChargers_availabilityAccess" />
                                        }
                                        type="button"
                                        className="availability-access-btn"
                                        onClick={() =>
                                          this.safeSetState(
                                            { selectedCharger: c },
                                            () =>
                                              this.setModal(
                                                "availabilityAccess",
                                                true
                                              )
                                          )
                                        }
                                      >
                                        <AvailabilityAccessIcon />
                                      </TooltipButton>
                                      <TooltipButton
                                        tooltip={
                                          <Translate value="chargerDetails_charge" />
                                        }
                                        type="button"
                                        className="charge-btn"
                                        onClick={() =>
                                          this.safeSetState(
                                            {
                                              selectedCharger: c,
                                              selectedPlug: p,
                                            },
                                            this.handleOnCharge
                                          )
                                        }
                                      >
                                        <EnergyIcon />
                                      </TooltipButton>
                                      <TooltipButton
                                        tooltip={
                                          <Translate value="chargerAsDetails_charge" />
                                        }
                                        type="button"
                                        className="charge-as-btn"
                                        onClick={() =>
                                          this.safeSetState(
                                            {
                                              selectedCharger: c,
                                              selectedPlug: p,
                                            },
                                            () =>
                                              this.setModal("chargeAs", true)
                                          )
                                        }
                                      >
                                        <EnergyIcon />
                                      </TooltipButton>
                                      <ModularButtonPopup
                                        label={<ThreeDotsIcon />}
                                        className="clear more-options-btn"
                                        popupClassName="modular-popup"
                                      >
                                        {this.props.isAdmin && (
                                          <TooltipButton
                                            tooltip={
                                              <Translate value="myChargers_configureKeys" />
                                            }
                                            tooltipOffset={this.getPopupRef}
                                            type="button"
                                            className="configure-keys-btn"
                                            onClick={() =>
                                              this.safeSetState(
                                                { selectedCharger: c },
                                                () =>
                                                  this.setModal(
                                                    "configureKeys",
                                                    true
                                                  )
                                              )
                                            }
                                          >
                                            <ConfigureKeysIcon />
                                          </TooltipButton>
                                        )}
                                        <TooltipButton
                                          tooltip={
                                            <Translate value="myChargers_logsDescription" />
                                          }
                                          tooltipOffset={this.getPopupRef}
                                          type="button"
                                          className="unlock-connector-btn"
                                          onClick={() =>
                                            this.safeSetState(
                                              { selectedCharger: c },
                                              () =>
                                                this.setState({
                                                  modalOpen: true,
                                                })
                                            )
                                          }
                                        >
                                          <LogsIcon />
                                        </TooltipButton>
                                        <TooltipButton
                                          tooltip={
                                            <Translate value="myChargers_unlockConnector" />
                                          }
                                          tooltipOffset={this.getPopupRef}
                                          type="button"
                                          className="unlock-connector-btn"
                                          onClick={() =>
                                            this.safeSetState(
                                              {
                                                selectedCharger: c,
                                                selectedPlug: p,
                                              },
                                              this.handleOnUnlockConnector
                                            )
                                          }
                                        >
                                          <UnlockConnectorIcon />
                                        </TooltipButton>
                                        <TooltipButton
                                          tooltip={
                                            <Translate value="myChargers_softReset" />
                                          }
                                          tooltipOffset={this.getPopupRef}
                                          type="button"
                                          className="reset-soft-btn"
                                          onClick={() =>
                                            this.safeSetState(
                                              {
                                                selectedCharger: c,
                                                selectedPlug: p,
                                              },
                                              () => this.handleOnReset("Soft")
                                            )
                                          }
                                        >
                                          <ResetSoftIcon />
                                        </TooltipButton>
                                        <TooltipButton
                                          tooltip={
                                            <Translate value="myChargers_hardReset" />
                                          }
                                          tooltipOffset={this.getPopupRef}
                                          type="button"
                                          className="reset-hard-btn"
                                          onClick={() =>
                                            this.safeSetState(
                                              {
                                                selectedCharger: c,
                                                selectedPlug: p,
                                              },
                                              () => this.handleOnReset("Hard")
                                            )
                                          }
                                        >
                                          <ResetHardIcon />
                                        </TooltipButton>
                                      </ModularButtonPopup>
                                    </div>
                                  </div>
                                )}
                              </div>
                            );
                          });
                        } else {
                          return (
                            <div
                              key={`${c.chargerId}.${k}`}
                              className="row no-gutters"
                            >
                              <div className="col-10 row no-gutters values slim no-cursor">
                                <div className="col">{c.name}</div>
                                <div className="col">
                                  <button
                                    type="button"
                                    className="link missing"
                                  >
                                    <Translate
                                      className="no-plugs"
                                      value="myChargers_waitingChargingCommunication"
                                    />
                                  </button>
                                </div>
                                <div className="col">
                                  <div className="qrcode-container">{"-"}</div>
                                </div>
                                <div className="col">
                                  <div className="status">
                                    {this.parseStatus(
                                      c.status,
                                      null,
                                      c.operationalStatus
                                    )}
                                  </div>
                                </div>
                                <div className="col">
                                  <button
                                    type="button"
                                    className="link"
                                    disabled
                                  >
                                    <Translate value="myChargers_missingTariff" />
                                  </button>
                                </div>
                                <div className="col-1 center">
                                  {this.props.isAdmin ? (
                                    c.operationalStatus === "APPROVED" ? (
                                      <TooltipButton
                                        tooltip={
                                          <Translate value="myChargers_unapproveCharger" />
                                        }
                                        type="button"
                                        className="clear admin-btn unapprove"
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          this.safeSetState(
                                            {
                                              selectedCharger: c,
                                              plugInfoTabIndex: 0,
                                            },
                                            () => {
                                              this.manageChargerApproval(
                                                "WAITINGAPROVAL"
                                              );
                                            }
                                          );
                                        }}
                                      >
                                        <ThumbDownIcon />
                                      </TooltipButton>
                                    ) : (
                                      <TooltipButton
                                        tooltip={
                                          <Translate value="myChargers_approveCharger" />
                                        }
                                        type="button"
                                        className="clear admin-btn approve"
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          this.safeSetState(
                                            {
                                              selectedCharger: c,
                                              plugInfoTabIndex: 0,
                                            },
                                            () => {
                                              this.manageChargerApproval(
                                                "APPROVED"
                                              );
                                            }
                                          );
                                        }}
                                      >
                                        <ThumbUpIcon />
                                      </TooltipButton>
                                    )
                                  ) : null}

                                  <button
                                    type="button"
                                    className="clear"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      this.safeSetState(
                                        { selectedCharger: c },
                                        () => this.setModal("editCharger", true)
                                      );
                                    }}
                                  >
                                    <img src={pencil} alt="edit" />
                                  </button>
                                  <button
                                    type="button"
                                    className="clear"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      this.safeSetState(
                                        { selectedCharger: c },
                                        () =>
                                          this.setModal("deleteCharger", true)
                                      );
                                    }}
                                  >
                                    <img src={trashcan} alt="delete" />
                                  </button>
                                </div>
                              </div>
                              <div className="col-2 center blank">
                                <div className="button-group">
                                  <TooltipButton
                                    tooltip={
                                      <Translate value="myChargers_availabilityAccess" />
                                    }
                                    type="button"
                                    className="availability-access-btn"
                                    onClick={() =>
                                      this.safeSetState(
                                        { selectedCharger: c },
                                        () =>
                                          this.setModal(
                                            "availabilityAccess",
                                            true
                                          )
                                      )
                                    }
                                    extended
                                  >
                                    <AvailabilityAccessIcon />
                                  </TooltipButton>
                                </div>
                              </div>
                            </div>
                          );
                        }
                      })}
                  </div>
                </div>
              </div>
              <button
                type="button"
                className="add-charger-btn"
                onClick={() => this.setModal("addCharger", true)}
                disabled={
                  this.state.loading ||
                  (this.props.isAdmin === false &&
                    this.state.selectedPlace.listChargers.length >=
                      this.props.userPackage?.chargersLimit)
                }
              >
                <Translate value="myChargers_addNewCharger" />
              </button>
            </>
          )}
        </div>

        <AddInfrastructure
          show={this.state.modals.add}
          onHide={() => {
            this.setModal("add", false);
            this.refreshContent();
          }}
          onSubmit={this.handleAddInfrastructure}
        />

        <EditInfrastructure
          show={this.state.modals.edit}
          onHide={() => {
            this.setModal("edit", false);
            this.refreshContent();
          }}
          onSubmit={this.handleEditInfrastructure}
          selectedPlace={this.state.selectedPlace}
        />

        <ConfirmationModal
          show={this.state.modals.delete}
          onHide={() => {
            this.setModal("delete", false);
            this.refreshContent();
          }}
          title="myChargers_deleteChargerPlace"
          body="myChargers_deleteChargerPlaceText"
          button="myChargers_deleteChargerPlace"
          onConfirm={this.handleDeleteInfrastructure}
        />

        {this.state.modalOpen && (
          <ViewLogsModal myChargerData={this.state} onClose={this.closeModal} />
        )}

        <ActionCharger
          show={this.state.modals.addCharger}
          onHide={() => {
            this.safeSetState({ selectedCharger: null }, () =>
              this.setModal("addCharger", false)
            );
            this.refreshContent();
          }}
          mode="add"
          selectedPlace={this.state.selectedPlace}
          onSubmit={this.handleAddCharger}
        />

        <ActionCharger
          show={this.state.modals.editCharger}
          onHide={() => {
            this.safeSetState({ selectedCharger: null }, () =>
              this.setModal("editCharger", false)
            );
            this.refreshContent();
          }}
          mode="edit"
          selectedPlace={this.state.selectedPlace}
          selectedCharger={this.state.selectedCharger}
          onSubmit={this.handleEditCharger}
        />

        <ConfirmationModal
          show={this.state.modals.deleteCharger}
          onHide={() => {
            this.safeSetState({ selectedCharger: null }, () =>
              this.setModal("deleteCharger", false)
            );
            this.refreshContent();
          }}
          title="myChargers_deleteCharger"
          body={
            this.props.isAdmin ? "" : "myChargersDeleteCharger_confirmation"
          }
          button={
            this.props.isAdmin
              ? "myChargers_deleteCharger"
              : "myChargers_requestSupport"
          }
          onConfirm={this.handleDeleteCharger}
        />

        <AvailabilityAccess
          show={this.state.modals.availabilityAccess}
          onHide={() => {
            this.safeSetState({ selectedCharger: null }, () =>
              this.setModal("availabilityAccess", false)
            );
            this.refreshContent();
          }}
          onSubmit={{
            availability: this.handleAvailabilityChange,
            access: this.handleAccessChange,
          }}
          selectedCharger={this.state.selectedCharger}
        />

        <PlugInfo
          show={this.state.modals.plugInfo}
          onHide={() => {
            this.safeSetState({ selectedCharger: null }, () =>
              this.setModal("plugInfo", false)
            );
            this.refreshContent();
          }}
          selectedCharger={this.state.selectedCharger}
          selectedPlug={this.state.selectedPlug}
          tabIndex={this.state.plugInfoTabIndex}
          setModal={(a, b, callback) => this.setModal(a, b, callback)}
          includeTariff
        />

        <ChargeAnimation
          show={this.state.modals.chargeAnim}
          onHide={() => {
            this.setModal("chargeAnim", false);
            this.refreshContent();
          }}
          chargerType={
            this.state.selectedCharger !== null
              ? this.state.selectedCharger.chargerType
              : 0
          }
          sessionId={this.state.sessionId}
          direction={1}
        />

        <ConfigurePlug
          show={this.state.modals.configurePlugs}
          onHide={() =>
            this.safeSetState({ selectedCharger: null }, () =>
              this.setModal("configurePlugs", false)
            )
          }
          selectedPlug={this.state.selectedPlug}
          selectedCharger={this.state.selectedCharger}
          onSubmit={this.handleEditCharger}
          onSuccess={() => {
            this.setModal("configurePlugs", false);
            this.fetchPlaces();
          }}
        />

        {this.state.modals.configureKeys && (
          <ConfigurationKeys
            show={this.state.modals.configureKeys}
            onHide={() =>
              this.safeSetState({ selectedCharger: null }, () =>
                this.setModal("configureKeys", false)
              )
            }
            selectedCharger={this.state.selectedCharger}
          />
        )}

        <ExportQR
          show={this.state.modals.exportQR}
          onHide={() => this.setModal("exportQR", false)}
          selectedCharger={this.state.selectedCharger}
          qrCodeId={
            this.state.selectedPlug !== null && this.state.selectedPlug.qrCodeId
          }
          handleOnExport={this.handleOnExportQRCode}
        />

        <ChargeAs
          show={this.state.modals.chargeAs}
          onHide={() => {
            this.safeSetState(
              { selectedCharger: null, selectedPlug: null },
              () => this.setModal("chargeAs", false)
            );
          }}
          onSubmit={{
            evs_chargeAs: this.handleEvsChargeAsChange,
            cards_chargeAs: this.handleCardsChargeAsChange,
          }}
          selectedCharger={this.state.selectedCharger}
          selectedPlug={this.state.selectedPlug}
        />
      </>
    ) : (
      <div className="loading-container">
        <div className="loading-spinner">
          <div className="generic-loading">
            <div></div>
            <div></div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  accountData: state.account.accountData,
  userPackage: state.account.accountData.userPackage,
  isAdmin: state.account.isAdmin,
  brand: state.app.brand,
});

export default connect(mapStateToProps, { setAlert })(MyChargers);
